<template>
  <div class="editor">
    <div class="column is-half is-offset-one-quarter has-text-left">
      <b-field label="Дата публикации" class="horizontal">
        <el-date-picker
          v-model="event.publishDate"
          :editable="false"
          type="date"
          format="dd.MM.yyyy">
        </el-date-picker>
      </b-field>
      <b-field label="Дата отсечки реестра" class="horizontal">
        <el-date-picker
          v-model="event.registryClippingDate"
          :editable="false"
          type="date"
          format="dd.MM.yyyy">
        </el-date-picker>
      </b-field>
      <div>
        <b-field label="Дата события" class="horizontal">
          <el-date-picker
            v-model="event.eventDate"
            :editable="false"
            type="date"
            format="dd.MM.yyyy">
          </el-date-picker>
        </b-field>
        <b-field label="Дата события по" class="horizontal">
          <el-date-picker
            v-model="event.eventEndDate"
            :editable="false"
            type="date"
            format="dd.MM.yyyy">
          </el-date-picker>
        </b-field>
      </div>
      <b-field label="Дата фиксации (если не указана дата отсечения)" class="horizontal">
        <el-date-picker
          v-model="event.fixationDate"
          :editable="false"
          type="date"
          format="dd.MM.yyyy">
        </el-date-picker>
      </b-field>
      <b-field label="Эмитент">
        <el-select
        v-model="selectedData"
        placeholder=""
        multiple
        filterable
        @change="dataSelected" class="emitents-data-select" v-if="emitentsData">
          <el-option v-for="item in filteredEmitents" :key="item.id" :label='item.value' :value='item.id'>
          </el-option>
        </el-select>
      </b-field>
      <b-field label="Событие">
        <b-input v-model='event.eventTitle' required></b-input>
      </b-field>
      <b-field label="Файл">
      </b-field>
      <div class="field has-addons has-addons-right" @click="changeFile">
        <p class="control is-expanded">
          <input class="input" placeholder="Выберите файл" :value="formatedEventFile" readonly></input>
        </p>
        <p class="control">
          <button class="button is-info">Изменить</button>
        </p>
      </div>
      <hr>
      <input class="input is-hidden" ref="fileInput" type="file" @change="setFile"></input>
      <button class="button is-fullwidth" @click="save">СОХРАНИТЬ</button>
      <router-link :to="{ name: 'EmitentNews' }" class="button is-fullwidth">ОТМЕНИТЬ</router-link>
    </div>
  </div>
</template>

<script>
import { DatePicker } from 'element-ui'
import lang from 'element-ui/lib/locale/lang/ru-RU'
import locale from 'element-ui/lib/locale'
import Multiselect from 'vue-multiselect'
import deepcopy from 'deepcopy'

import moment from 'moment'
import { mapState, mapActions } from 'vuex'

locale.use(lang)
moment.locale('ru')

export default {
  name: 'EventsEditor',
  data () {
    return {
      selectedData: [],
      filteredEmitents: [],
      yesterday: new Date(new Date().setDate(new Date().getDate() - 1)),
      event: {
        publishDate: new Date(),
        registryClippingDate: new Date(),
        eventDate: new Date(),
        eventEndDate: null,
        fixationDate: null,
        data: [],
        emitent: '',
        eventTitle: '',
        stockNumber: '',
        file: ''
      }
    }
  },
  components: {
    [DatePicker.name]: DatePicker,
    Multiselect
  },
  created () {
    this.getEvents()
    .then(() => {
      if (this.$route.params.id) {
        this.event = this.deponentsCopy.find(e => e.id === this.$route.params.id) || this.event
        this.selectedData = this.event.data
      }
    })
    this.getDeponentsData()
  },
  computed: {
    ...mapState(['deponentsData', 'emitentsData']),
    formatedEventFile () {
      const fileData = this.event.file.path || this.event.file
      return fileData.split('/').pop()
    },
    deponentsCopy () {
      return deepcopy(this.deponentsData)
    }
  },
  methods: {
    ...mapActions(['getEvents', 'getDeponentsData', 'saveEmitentEvent']),
    changeFile () {
      this.$refs.fileInput.click()
    },
    hidePicker (ev) {
    },
    setFile (event) {
      this.event.file = {
        file: event.target.files[0],
        path: event.target.files[0].name
      }
    },
    filterEmitents () {
      const emitent = this.emitentsData.find(e => e.id === this.selectedData[0]).emitent
      this.filteredEmitents = this.emitentsData.filter(e => e.emitent === emitent)
    },
    dataSelected () {
      if (this.selectedData.length >= 1) {
        this.filterEmitents()
      } else if (this.selectedData.length === 0) {
        this.filteredEmitents = this.emitentsData
      }
      this.event.data = this.selectedData
    },
    save () {
      if (!this.event.fixationDate && !this.event.registryClippingDate) {
        this.$dialog.alert({
          message: 'Введите дату фиксации или дату отсечения реестра',
          confirmText: 'OK'
        })
      } else {
        this.event.data = this.selectedData
        this.saveEmitentEvent(this.event)
        .then(() => {
          this.$router.push({ name: 'EmitentNews' })
        })
      }
    }
  },
  watch: {
    emitentsData (val) {
      if (this.selectedData.length === 0) {
        this.filteredEmitents = val
      } else {
        this.filterEmitents()
      }
    }
  }
}
</script>

<style>
 .horizontal {
   display: inline-block;
 }
 .emitents-data-select {
   width: 100%;
 }
 .editor .field.horizontal {
   margin: 0 15px 15px 0;
 }
</style>



// WEBPACK FOOTER //
// Editor.vue?3c54dcc4